import { FC } from 'react';
import Form from '../components/Form';

const Login: FC = () => {
  return (
    <div className="login">
      <Form />
    </div>
  );
};

export default Login;
